module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', {
    attrs: {
      "is-show-back": false
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("收银管理")])]), _vm._v(" "), _c('z-tabbar', {
    attrs: {
      "list-obj": _vm.tabbarList
    }
  }), _vm._v(" "), _c('section', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    staticClass: "view"
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-f4a03f70","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/pay_manage/Index.vue
// module id = 894
// module chunks = 0